export default class HiddenError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "HiddenError";
  }
}
